export default "__VITE_ASSET__DNTdkdUi__"